import { apiRoutesV2 } from "routes";
import FetchHelpers from "utils/FetchHelpers";

export default {
  create(params) {
    const url = apiRoutesV2.invites();
    return FetchHelpers.post(url, params);
  },
  show(slug) {
    const url = apiRoutesV2.invites(slug);
    return FetchHelpers.get(url, { include: "guests" });
  },
  addGuest(slug, params) {
    const url = apiRoutesV2.inviteGuests(slug);
    return FetchHelpers.post(url, params);
  },
};
